import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ADMINMENU, ANALYSTMENU, REGULATORMENU, EDITORMENU, OWNERMENU } from './menu';
import { INTERNALADMINMENU, INTERNALEDITORMENU, RESEARCHERMENU, RESEARCHERADMINMENU } from './internal-menu';
import { MenuItem } from './menu.model';
import { AuthService } from 'src/app/services/auth.service';
import { LanguageService } from 'src/app/services/language.service';
import { CreateUserComponent } from 'src/app/shared/components/create-user/create-user.component';
import { AssignProjectMemberComponent } from 'src/app/shared/components/assign-project-member/assign-project-member.component';
import { CreateProjectComponent } from 'src/app/shared/components/create-project/create-project.component';
import { CreateResearchProjectComponent } from 'src/app/shared/components/create-research-project/create-research-project.component';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false
})
export class TopbarComponent implements OnInit, AfterViewInit {
	
	@ViewChild('createUser') createUserModal!: CreateUserComponent;
	@ViewChild('assignProjectMember') assignProjectMemberModal!: AssignProjectMemberComponent;
	@ViewChild('createProject') createProjectModal!: CreateProjectComponent;
	@ViewChild('createResearchProject') createResearchProjectModal!: CreateResearchProjectComponent;

	menu: any;
  menuItems: MenuItem[] = [];
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(public languageService: LanguageService, private authService: AuthService) {
    this.languageService.setLanguage('en');
  }
	
  ngOnInit(): void {
		if (this.authService.currentResearchUserValue) {
			const isAdmin = this.authService.currentResearchUserValue.role === 'ADMIN';
			this.menuItems = isAdmin ? RESEARCHERADMINMENU : RESEARCHERMENU;
			return;
		}
		switch(this.authService.role) {
			case 'ADMIN': 
			this.menuItems = this.authService.currentClientValue.client_id === 0 ? INTERNALADMINMENU : ADMINMENU;
      break;
      case 'ANALYST':
        this.menuItems = ANALYSTMENU;
      break;
      case 'REGULATOR':
        this.menuItems = REGULATORMENU;
      break;
      case 'EDITOR':
        this.menuItems = this.authService.currentUserValue?.client_id == 0 ? INTERNALEDITORMENU : EDITORMENU;
        break;
      case 'OWNER':
        this.menuItems = OWNERMENU;
        break;
    }
  }

  /***
   * Activate droup down set
   */
   ngAfterViewInit() {
    this.initActiveMenu();
  }

  removeActivation(items: any) {   
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }

  // remove active items of two-column-menu
  activateParentDropdown(item: any) { // navbar-nav menu add active
    item.classList.add("active");
    const parentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (parentCollapseDiv) {      
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
        parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.setAttribute("aria-expanded", "true");
      }
      return false;
    }
    return false;
  }

  updateActive(event: any) {
    const ul = document.getElementById("navbar-nav");
    
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
  }

  initActiveMenu() {
    const pathName = window.location.pathname;
    const ul = document.getElementById("navbar-nav");
    
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      const activeItems = items.filter((x: any) => x.classList.contains("active")); 
      this.removeActivation(activeItems);
      const matchingMenuItem = items.find((x: any) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }

  toggleSubItem(event: any) {
    if(event.target && event.target.nextElementSibling) {
      event.target.nextElementSibling.classList.toggle("show");
		}
  }

  toggleItem(event: any) {
    const isCurrentMenuId = event.target.closest('a.nav-link');    
    
    const isMenu = isCurrentMenuId.nextElementSibling as any;
    const dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });

    (isMenu) ? isMenu.classList.add('show') : null;

    const ul = document.getElementById("navbar-nav");
    if(ul){
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      const activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    } 
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
  }


  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

	onClick(modal: string) {
		switch (modal) {
			case 'userModal':
				this.createUserModal.openModal('create');
				break;
			case 'assignModal':
				this.assignProjectMemberModal.openModal(false);
				break;
			case 'researchProjectModal':
				this.createResearchProjectModal.openModal();
				break;
			case 'projectModal':
				this.createProjectModal.openModal();
				break;
			default:
				break;
		}
	}
}
